<template>
    <div>
        <div v-if="authUserPermission['stock-calc-slow-by-manual']">
            <base-header class="pb-6">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-7">
                        <h6 class="h2 text-white d-inline-block mb-0"></h6>
                    </div>
                </div>
            </base-header>
            <div class="container-fluid mt--6">
                <div class="card mb-4">
                    <div class="card-body">
                        <div class="row no-gutters justify-content-center mb-4">
                            <div class="col">
                                <button class="btn-sm btn m-0 w-100 rounded-0 p-2"
                                :class="params.flag == 3 ? 'btn-darks' : 'btn-light'" @click="swithcTab(3)">
                                Waiting Approval</button>
                            </div>
                            <div class="col">
                                <button class="btn-sm w-100 btn-rounded-non btn p-2"
                                :class="params.flag == 4 ? 'btn-darks' : 'btn-light'" @click="swithcTab(4)">
                                History Approval</button>
                            </div>
                        </div>

                        <div class="d-flex justify-content-end align-items-center mb-4">
                            <div class="mr-2">
                                <button class="btn" :class="activeFilter ? 'btn-danger' : 'btn-light'" @click="clearFilter">Clear Filter</button>
                            </div>
                            <div class="mr-2">
                                <button class="btn btn-primary" @click="openModalFilter">filter</button>
                            </div>
                        </div>

                        <div v-if="submissions.length > 0" v-for="(item, index) in submissions" :key="index"
                            class="row justify-content-between align-items-center bg-light py-3 mb-3 mr-1 ml-1 rounded cursor-pointer"
                            @click="goToDetail(item)"
                        >
                            <div class="col-md-5">
                                <div class="mb-1 font-weight-bold">{{ item?.title }}</div>
                                <small>{{ formatTanggal(item.created_at) }}</small>
                            </div>
                            <div class="col-md-5">
                                <div class="font-weight-bold">{{ item.sales_org_description }}</div>
                                <small>{{ item.items_count }} Matcode</small>
                            </div>
                            <div class="col-md-2 text-right">
                                <span style="font-size: 11px;" class="px-3 py-2 text-white font-weight-normal rounded" :class="{
                                    'bg-yellow': item.status == 1,
                                    'bg-primary': item.status == 2,
                                    'bg-warning': item.status == 3,
                                    'bg-success': item.status == 4,
                                    'bg-danger': item.status == 5,
                                }">
                                    {{ item.status_text }}
                                </span>
                            </div>
                        </div>

                        <div v-if="submissions.length == 0">
                            <div class="alert alert-light text-center" role="alert">
                                <i class="fas fa-exclamation-circle"></i> No Data
                            </div>
                        </div>

                         <div class="card-footer pb-0 ">   
                            <div class="d-flex justify-content-center">
                                <span class="float-left">
                                    <base-pagination :page-count="pagination.last_page" v-model="pagination.current_page" @click.native="handlePaginate(pagination.current_page)" size="sm"></base-pagination>
                                </span>                             
                            </div>
                            <div class="d-flex justify-content-center">
                                <span>
                                    {{ tt('page_info', {size: (pagination.current_page - 1) * pagination.per_page + submissions.length, total: pagination.total}) }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <modal-filter
                :filter="params"
                :visible-modal-filter.sync="visibleModalFilter"
                :loading-filter.sync="loadingFilter"
                @submit-filter="handleFilter"
            />
        </div>
        <noaccess v-else />
    </div>
</template>
<script>
import { mapState } from 'vuex'
import Api from '@/helpers/api';
import Empty from '../../components/Empty.vue';
import stockCalcService from '@/services/material/stockCalculation.service';
import moment from 'moment';
import 'moment/locale/id' 
import ModalFilter from '@/views/StockCalculation/Components/ModalFilter.vue';

export default {
    name: 'ApprovalStockCalcSubmissions',
    components: { Empty, ModalFilter },
    data() {
        return {
            submissions: [],
            params: {
                per_page: 5,
                page: 1,
                flag: 3,
                title: '',
                company_code: '',
                created_at: ''
            },
             pagination: {
                current_page: 0,
                last_page: 0,
                per_page: 0,
                total: 0,
            },
            visibleModalFilter: false,
            loadingFilter: false,
            activeFilter: false
        }
    },
    methods: {
          openModalFilter() {
            this.visibleModalFilter = true;
        },
        handleFilter() {
            if (this.params.title || this.params.company_code || this.params.created_at) {
                this.activeFilter = true
            }
            this.getSubmissions()
        },
        clearFilter(){
            this.params.company_code = ''
            this.params.title = ''
            this.params.created_at = ''
            this.activeFilter = false
            this.getSubmissions()
        },
        handlePaginate(page) {
            this.params.page = page
            this.getSubmissions()
        },
        swithcTab(value) {
            if (this.params.flag != value) {
                this.params.flag = value
                this.getSubmissions()
            }
        },
        getSubmissions()
        {
            this.loadingFilter = true;
            Api(this, stockCalcService.getSubmissions(this.params))
            .onSuccess((response) => {
                this.submissions = response.data.data.data
                this.pagination = {
                    current_page: response.data.data.current_page,
                    last_page: response.data.data.last_page,
                    per_page: response.data.data.per_page,
                    total: response.data.data.total,
                }
            })
            .onError((error) => {
                const errorMessage = error?.response?.data?.message ?? 'Gagal, Terjadi kesalahan.'
                this.$notify({
                    message: errorMessage,                  
                    type: 'danger',
                    verticalAlign: "bottom",
                    horizontalAlign: "left"
                }); 
            })
            .onFinish(() => {
                this.loadingFilter = false;
                this.visibleModalFilter = false;
            })
            .call()
        },
        formatTanggal(value) {
            if (!value) return '-';
            return moment(value).format('D MMMM YYYY');
        },
        goToDetail(item) {
            this.$router.push(`/stock-calculation/stock-calc-submissions/${item?.id}?flag=${this.params.flag}`);
        }
    },
    created() {
        moment.locale('id')

        const flag = this.$route.query.flag;
        this.params.flag = flag ? parseInt(flag) : 3
    },
    computed: {
        ...mapState({
            authUserPermission: state => state.auth.userPermission
        })
    },
     mounted() {
        this.getSubmissions();
    },
};
</script>


<style scoped>
.el-tooltip__popper {
    max-width: 320px !important;
    word-break: break-word;
}

.btn-darks {
    background-color: #172b4d !important;
    color: white;
}

.badge {
    border-radius: 6px;
    font-size: 0.75rem;
}

.bg-yellow {
    background-color: yellow!important;
    color: silver!important;
}
.cursor-pointer {
  cursor: pointer!important;
}
</style>